import { render, staticRenderFns } from "./InspectionsCommentsTable.vue?vue&type=template&id=ffaba954&scoped=true"
import script from "./InspectionsCommentsTable.vue?vue&type=script&lang=js"
export * from "./InspectionsCommentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaba954",
  null
  
)

export default component.exports